
export enum ContractStatus {
    Active = "345ca1be-ac4c-45f5-b6f3-3c7924fc2d6b",
    Inactive = "e62b6586-6ff9-4389-9028-2c1b82036862",
    Trial = "a74e91d1-b802-47d2-80b1-65a06f7968e8",
    EndTrial = "c9f8db0d-9ca6-4dc0-9fbe-881f9faa96dc",
}